// extracted by mini-css-extract-plugin
export var arrowsContainer = "carousel-module--arrowsContainer--77183";
export var card = "carousel-module--card--ee8a4";
export var cardsContainer = "carousel-module--cardsContainer--d3e73";
export var date = "carousel-module--date--b267d";
export var linkTitle = "carousel-module--linkTitle--d7a2c";
export var spanAnimated = "carousel-module--spanAnimated--c21f1";